import axios from 'axios';
import { parseChatTargets } from '@/general/converters/targetConverters';
import { OutletId } from '@/shared/models/Outlet';
import { present } from '@/shared/utils/typescript';
import { parseChat } from '../converters/chatConverters';
import Chat from '../models/Chat';
import ChatTargetContainer from '../models/ChatTargetContainer';
import { ChatId } from '../models/ids';

export default class ChatClient {
  static async load(id: ChatId): Promise<Chat> {
    const response = await axios.get(`/api/mobopro/v1/chat/${id}`);
    return present(parseChat(response.data));
  }

  static async markAsRead(id: ChatId): Promise<void> {
    await axios.put(`/api/mobopro/v1/MarkChatAsRead?chatId=${id}`);
  }

  static async loadInternalTargets(outledId: OutletId): Promise<ChatTargetContainer> {
    const response = await axios.get(`/api/mobopro/v2/internaldialogmessages/outletusers?moboOutletId=${outledId}`);
    return present(parseChatTargets(response.data));
  }
}
